import React from 'react'
import { DeltaTrialTimelineContainer } from '../Timeline/DeltaTrialTimelineContainer'
import { formatPrice } from '../utils'
import { DeltaTrialTimelineElement } from '../Timeline/DeltaTrialTimelineElement'
import { DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const ZapierIntegrationTimeline: React.FC<DeltaTrialTimelineProps> = ({ deltaTrialDays, proratedPrice }) => {
  return (
    <DeltaTrialTimelineContainer>
      <DeltaTrialTimelineElement day='Today' text='Start using the Zapier Integration immediately — no restrictions.' icon='bi-rocket-takeoff-fill' />
      <DeltaTrialTimelineElement day='Day 2' text='You’ll receive setup guides and resources to get started quickly.' icon='bi-gear-fill' />
      <DeltaTrialTimelineElement day={`Day ${deltaTrialDays - 14}`} text='You’ll get a reminder 14 days before the trial is up.' icon='bi-bell-fill' />
      <DeltaTrialTimelineElement
        day={`Day ${deltaTrialDays}`}
        text={`Trial ends. Continue with the ${proratedPrice ? formatPrice(proratedPrice) : 'Unknown'} prorated charge or cancel.`}
        icon='bi-star-fill'
      />
    </DeltaTrialTimelineContainer>
  )
}
